import React, { useCallback, useEffect, useState } from "react";
import { CustomDialog } from "../../../../../../components/customDialog/CustomDialog";
import GrillaVacia from '../../../../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import DataGridGenerico from '../../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CustomButton } from "../../../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from '../../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import toast, { Toaster } from 'react-hot-toast';
import { Box } from "@mui/material";

export const TratamientoInput = ({
    handleChange,
    prevTratamientos,
    setChildrenAction,
    fieldName,
    readOnly = false
}) => {
    const [openModal, setOpenModal] = useState(false);
    const tratamientosInitial = prevTratamientos?.map(tratamiento => ({ tratamiento })) || [];
    const [tratamientosAux, setTratamientosAux] = useState(tratamientosInitial);
    const [nuevoTratamiento, setNuevoTratamiento] = useState('');

    const handleChangeTratamiento = (value) => {
        setNuevoTratamiento(value);
    }
    useEffect(() => {
        setTratamientosAux(prevTratamientos?.map(tratamiento => ({ tratamiento })) || []);
    }, [prevTratamientos]);

    const handleOpenModal = () => setOpenModal(true);

    const handleClose = () => {
        setNuevoTratamiento('');
        setOpenModal(false);
    }

    const handleAccept = useCallback(() => {
        if (tratamientosAux.some(t => t.tratamiento === nuevoTratamiento)) {
            toast.error("El valor ingresado ya existe en el listado");
        } else {
            setTratamientosAux((prevTratamientos) => ([
                ...prevTratamientos,
                { tratamiento: nuevoTratamiento }
            ]));
            handleClose();
        }
    }, [setTratamientosAux, nuevoTratamiento, tratamientosAux]);

    const columns = generateColumnsDefaultConfiguration([
        {
            field: 'action',
            headerName: '',
            flex: 0.1,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    !readOnly && <DeleteOutlineIcon className='edit-icon' onClick={() => deleteTratamiento(row.tratamiento)} />
                )
            }
        },
        {
            headerName: 'Tratamientos',
            field: 'tratamiento',
            flex: 0.7
        },
        {
            field: 'action2',
            headerName: '',
            flex: 0.2
        }
    ]);

    const deleteTratamiento = useCallback((tratamientoValue) => {
        setTratamientosAux((prevTratamientos) => (
            prevTratamientos.filter((item) => item.tratamiento !== tratamientoValue)
        ));
    }, [setTratamientosAux]);

    useEffect(() => {
        handleChange(fieldName, tratamientosAux.map(t => t?.tratamiento));
    }, [nuevoTratamiento]);

    useEffect(() => {
        if (!tratamientosAux.length) return setChildrenAction(null);

        setChildrenAction(() => (
            <CustomButton
                onClick={handleOpenModal}
                disabled={readOnly}
                size='small'
                variant='outlined'
            >
                Agregar
            </CustomButton>
        ));

    }, [tratamientosAux, prevTratamientos, readOnly]);

    return (
        <>
            
            {!tratamientosAux?.length && <div className='resumen-ingreso-grilla-vacia'>
                <div className='svg-clientes-grilla-vacia'>
                    <img src={GrillaVacia} width='100%'></img>
                </div>
                <label>No se ha agregado ningún tratamiento</label>
                <CustomButton
                    onClick={handleOpenModal}
                    size='small'
                >
                    Agregar
                </CustomButton>
            </div>}
            {!!tratamientosAux.length && (
                <Box sx={{width: '100%'}}>
                    <DataGridGenerico
                        columns={columns}
                        rows={tratamientosAux}
                        toolbar={false}
                        hideFooter
                    />
                </Box>
            )}
            <CustomDialog
                maxWidth='md'
                fullWidth
                onCancel={handleClose}
                open={openModal}
                cancelText='Cerrar'
                onAccept={handleAccept}
                acceptDisabled={nuevoTratamiento === ''}
                acceptText='Aceptar'
                title='Tratamiento'
            >
                <RenderInputByTypeMobile
                    grided
                    handleChange={(_, value) => handleChangeTratamiento(value)}
                    input={{
                        name: 'tratamiento',
                        displayName: 'Medicación y dosificación',
                        type: 'string',
                        required: true
                    }}
                    value={nuevoTratamiento}
                />
            </CustomDialog>
        </>
    );
}

export default TratamientoInput;